import React, { useEffect, useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import formValidation from "integrations/aws/utils/formValidation";
import { validateExternalIdRequiresArn } from "integrations/aws/utils/awsValidation";
import { ApiRoutes } from "./common/Routes";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import AWSAuthenticationTypes from "../authentication/AWSAuthenticationTypes";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    fetch("GET", qualifyUrl(ApiRoutes.INTEGRATIONS.AWSCloudTrail.GET_AWS_REGIONS)).then((response) => {
      const region = Object.keys(response).map((key) => ({ label: response[key], value: key }));
      setRegions(region);
    });
  }, []);
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { awsSecretKey } = formData;
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const externalIdError = validateExternalIdRequiresArn(
      (_a = formData == null ? void 0 : formData.awsAssumeRoleARN) == null ? void 0 : _a.value,
      (_b = formData == null ? void 0 : formData.awsExternalId) == null ? void 0 : _b.value
    );
    if (externalIdError) {
      setFormError({
        full_message: externalIdError,
        nice_message: externalIdError
      });
      return;
    }
    setLoading(true);
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.AWSCloudTrail.CHECK_CREDENTIALS), {
      aws_access_key: ((_c = formData == null ? void 0 : formData.awsAccessKey) == null ? void 0 : _c.value) || "",
      aws_secret_key: ((_d = formData == null ? void 0 : formData.awsSecretKey) == null ? void 0 : _d.value) || "",
      aws_sqs_queue_name: ((_e = formData == null ? void 0 : formData.awsCloudTrailSqsQueueName) == null ? void 0 : _e.value) || "",
      aws_sqs_region: ((_f = formData == null ? void 0 : formData.awsCloudTrailSqsRegion) == null ? void 0 : _f.value) || "",
      aws_s3_region: ((_g = formData == null ? void 0 : formData.awsCloudTrailS3Region) == null ? void 0 : _g.value) || "",
      assume_role_arn: ((_h = formData == null ? void 0 : formData.awsAssumeRoleARN) == null ? void 0 : _h.value) || "",
      aws_external_id: ((_i = formData == null ? void 0 : formData.awsExternalId) == null ? void 0 : _i.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to AWS CloudTrail using provided configuration."
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to AWS CloudTrail using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["awsCloudTrailName", "awsCloudTrailSqsRegion", "awsCloudTrailS3Region", "awsCloudTrailSqsQueueName"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "awsCloudTrailName",
        type: "text",
        fieldData: formData.awsCloudTrailName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: awsSecretKey == null ? void 0 : awsSecretKey.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(AWSAuthenticationTypes, { onChange, requireCredentials: false }),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "awsCloudTrailSqsRegion",
        onChange,
        fieldData: formData.awsCloudTrailSqsRegion,
        help: "AWS region where the SQS queue is located.",
        required: true,
        label: "AWS SQS Region"
      },
      renderOptions(regions, "Choose SQS region", false)
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "awsCloudTrailS3Region",
        onChange,
        fieldData: formData.awsCloudTrailS3Region,
        help: "AWS region where the S3 bucket is located.",
        required: true,
        label: "AWS S3 Region"
      },
      renderOptions(regions, "Choose S3 region", false)
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "awsCloudTrailSqsQueueName",
        type: "text",
        onChange,
        fieldData: formData.awsCloudTrailSqsQueueName,
        help: "SQS queue name created by the CloudTrail Subscriber",
        label: "SQS Queue Name",
        required: true
      }
    )
  );
};
export default StepAuthorize;
